import type { FaqEntry } from "@/lib/json-ld";

export const MOBILE_PRICING_FAQS: FaqEntry[] = [
  {
    q: "What is the price of the Proxidize Mobile Proxies?",
    a: "Proxidize Mobile Proxies are monthly bandwidth packages priced at $2/GB at every self-serve tier, from $50 for 25 GB up to 10 TB. Included bandwidth expires after one month. Custom volume pricing is available above 10 TB — contact sales for a quote.",
  },
  {
    q: "Does city or ASN targeting cost extra?",
    a: "No. City and ASN targeting are included in Proxidize's $2/GB mobile proxy plans, with no additional targeting surcharge. Availability depends on the selected location and network.",
  },
  {
    q: "Can I upgrade or downgrade my plan?",
    a: "Yes. Each subscription is standalone, so you can upgrade or downgrade at any time without affecting your other subscriptions.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept all credit/debit cards.",
  },
  {
    q: "Does unused Per GB data roll over?",
    a: "No. Per GB bandwidth expires after one month. If rollover bandwidth is important to your workflow, consider Proxidize residential proxies where unused data carries over indefinitely.",
  },
  {
    id: "money-back-guarantee",
    q: "Is there a money-back guarantee?",
    a: "Yes. All plans include a 30-day money-back guarantee, conditional on using less than 10 GB of data.",
  },
  {
    q: "Are there any usage restrictions?",
    a: "Proxidize mobile proxies can be used for all legal use cases. The only exceptions are adult industry sites and .gov domains.",
  },
  {
    q: "Is KYC required?",
    a: "Yes. We require KYC (Know Your Customer) verification from all customers to maintain compliance and prevent misuse of our network.",
  },
  {
    q: "Do I need to contact sales to get started?",
    a: "No. Pick a plan, pay, and your credentials are ready in under 30 seconds. Enterprise customers needing custom infrastructure, SLAs, or volume pricing can contact sales.",
  },
  {
    q: "Can I try before I pay?",
    a: "No, you'll need to pay to get started. But every plan includes a 30-day money-back guarantee, conditional on using less than 10 GB of data.",
  },
];
